import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { campaignPath } from './paths';

/**
 * `/incidents/:id`. The incident screen is gone: remediation belongs to a campaign, so an old link goes to the
 * campaign of that incident (a lone incident opens as a campaign of one). The campaign route resolves which.
 */
const IncidentRedirect: React.FC = () => {
  const { id = '' } = useParams();
  return <Navigate to={campaignPath(id)} replace />;
};

export default IncidentRedirect;
